import React, { Fragment } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import LocationItem from "./LocationItem";

const LocationField = ({ 
    location, 
    field, 
    locationFilters,
    handleMoveLocationItem,
    handleRemoveLocationItem
    }) => {

    return (
        <Fragment>
            {
                {
                    "name": 
                        <td>
                            <strong>
                                {location.name}
                            </strong>
                        </td>,
                    "updatedAt":
                        <td className="text-center">
                            {(new Date(location.updatedAt)).toLocaleString('es-CL')}
                        </td>,
                    "inventory": 
                        <td>
                            {location.inventory.length > 0
                            ? <Row className="m-auto">
                            {location.inventory
                                .sort((a, b) => (a.sku > b.sku) - (a.sku < b.sku))
                                .map((item, index) => (
                                    <Col sm={12} md={6} lg={4} xl={3} className="p-0" key={"item_" + index}>
                                        <LocationItem
                                            location={location}
                                            item={item}
                                            locationFilters={locationFilters}
                                            handleMoveLocationItem={handleMoveLocationItem}
                                            handleRemoveLocationItem={handleRemoveLocationItem}
                                        />
                                    </Col>
                                ))
                            }
                            </Row>
                            : <Row>
                                <Col>
                                    Sin ítems en la ubicación
                                </Col>
                            </Row>
                            }
                        </td>,
                }[field]
            }
        </Fragment>
    );
};

export default LocationField;
